/*
 *		Copyright (c) 2011-2018 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Nodes')
    .factory('purgeAllRevisions', ['$rootScope', '$q', '$translate', 'NodeRevision', 'confirmAction', 'operationComplete',
        function($rootScope, $q, $translate, NodeRevision, confirm, operationComplete) {
            return function(nodes) {
                _confirm(nodes).then(function() {
                    _purgeAllRevisions(nodes);
                });
            }

            function _confirm(nodes) {
                return confirm({}, {
                    confirmTitle: $translate.instant('purge_all_file_revisions_dialog_header', {COUNT: nodes.length}, 'messageformat'),
                    confirmSubmit: $translate.instant('purge_all_file_revisions_button_text'),
                    confirmBodyTemplate: 'modals/actions/confirm_purge_all_file_revisions',
                    modalUpdate: function(modalScope) {
                        modalScope.nodes = nodes;
                    }
                });
            }

            function _purgeAllRevisions(nodes) {
                var promises = [];

                angular.forEach(nodes, function(node) {
                    promises.push(NodeRevision.purgeAll({node_uuid: node.uuid}).$promise);
                })

                $q.all(promises).then(function() {
                    $rootScope.$broadcast('reload.dataTable');
                    $rootScope.$broadcast('reload.contentStats');
                    $rootScope.account.$get();
                    operationComplete('files_permanently_deleted_message', {COUNT: nodes.length}, 'messageformat');
                });
            }
        }]);
